import { Card, Grid } from "@mui/material";
import { BarChartOutlined } from "@mui/icons-material";
import { mutate } from "swr";
import { CustomAutocomplete } from "../../../../components/custom/CustomAutocomplete";
import useResponsive from "../../../../components/hooks/useResponsive";
import { sendData } from "../../../../lib/dashboard/actions";
import AddToFavoritesButton from "../../../../components/favorite/AddToFavoritesButton";
import Loading from "../../../../components/loader/Loading";
import { useDomesticMarketProductPriceChartCategory } from "../../../../context/domestic-market/product-price-chart/DomesticMarketProductPriceChartCategoryContext";

const CategoryForm = () => {
  const {
    industries,
    fields,
    companies,
    groups,
    commodities,
    inputValues,
    setInputValues,
    isLoadingChart,
    handleShowChart,
    isFavoritesValidation,
  } = useDomesticMarketProductPriceChartCategory();

  const { isXl } = useResponsive();

  const { industry, field, company, group, commodity } = inputValues;

  const body = {
    industry_id: industry?.id,
    field_id: field?.id,
    group_id: group?.id,
    company_id: company?.id,
    commodity_id: commodity?.id,
  };

  const handleAddToFavorite = async () => {
    const res = await sendData(body, "/favorite/domestic-price/category");
    if (res.status === 200) await mutate("/favorite/domestic-price/category");
  };

  const clearForm = (field) => {
    switch (field) {
      case "industry":
        setInputValues((prev) => ({
          ...prev,
          field: null,
          group: null,
          company: null,
          commodity: null,
        }));
        break;
      case "field":
        setInputValues((prev) => ({
          ...prev,
          group: null,
          company: null,
          commodity: null,
        }));
        break;
      case "group":
        setInputValues((prev) => ({
          ...prev,
          company: null,
          commodity: null,
        }));
        break;
      case "company":
        setInputValues((prev) => ({
          ...prev,
          commodity: null,
        }));
        break;

      default:
        break;
    }
  };

  const isDisabled = [industry?.id, field?.id].every(Boolean);

  return (
    <Card>
      <Grid container spacing={1} alignItems={"center"}>
        {isXl && (
          <Grid item xs={12} md={6} xl={isXl ? 0.5 : 1}>
            <AddToFavoritesButton
              onClick={handleAddToFavorite}
              isDisabled={!isDisabled}
              style={{ height: "43px" }}
              isLoading={isFavoritesValidation}
            />
          </Grid>
        )}

        <Grid item xs={12} md={6} xl={2}>
          <CustomAutocomplete
            options={industries.data}
            value={industry}
            onChange={(e, newValue) => {
              setInputValues((prev) => ({
                ...prev,
                industry: newValue,
              }));
              clearForm("industry", newValue);
            }}
            isLoading={industries.isLoading}
            placeholder="صنعت"
          />
        </Grid>
        <Grid item xs={12} md={6} xl={2}>
          <CustomAutocomplete
            options={fields.data}
            value={field}
            onChange={(e, newValue) => {
              setInputValues((prev) => ({ ...prev, field: newValue }));
              clearForm("field", newValue);
            }}
            isLoading={fields.isLoading}
            placeholder="زمینه"
          />
        </Grid>

        <Grid item xs={12} md={6} xl={2}>
          <CustomAutocomplete
            options={groups.data}
            value={group}
            onChange={(e, newValue) => {
              setInputValues((prev) => ({ ...prev, group: newValue }));
              clearForm("group", newValue);
            }}
            isLoading={groups.isLoading}
            placeholder="گروه"
          />
        </Grid>

        <Grid item xs={12} md={6} xl={2}>
          <CustomAutocomplete
            options={companies.data}
            value={company}
            onChange={(e, newValue) => {
              setInputValues((prev) => ({ ...prev, company: newValue }));
              clearForm("company", newValue);
            }}
            isLoading={companies.isLoading}
            placeholder="شرکت (اختیاری)"
          />
        </Grid>

        <Grid item xs={12} md={6} xl={2}>
          <CustomAutocomplete
            options={commodities.data}
            value={commodity}
            onChange={(e, newValue) => {
              setInputValues((prev) => ({
                ...prev,
                commodity: newValue,
              }));
              clearForm("commodity", newValue);
            }}
            isLoading={commodities.isLoading}
            placeholder="کالا (اختیاری)"
          />
        </Grid>

        <Grid item xs={10} md={5} xl={isXl ? 1.5 : 1.25}>
          <button
            style={{ height: "43px" }}
            onClick={() => handleShowChart(body)}
            className={`btn ${!isDisabled ? " btn-softblue" : "btn-blue"}`}
            disabled={!isDisabled || isLoadingChart}
          >
            {isLoadingChart ? (
              <Loading color={"#fff"} />
            ) : (
              <>
                نمایش
                <BarChartOutlined />
              </>
            )}
          </button>
        </Grid>

        {!isXl && (
          <Grid item xs={2} md={1}>
            <AddToFavoritesButton
              onClick={handleAddToFavorite}
              isDisabled={!isDisabled}
              style={{ height: "43px" }}
              isLoading={isFavoritesValidation}
            />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default CategoryForm;
